import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import classNames from 'classnames'
import {memo, useCallback} from 'react'

import Actions from '../../../../../components/Actions/Actions'
import EditButton from '../../../../../components/EditButton/EditButton'
import JobTriggerForm from '../JobTriggerForm/JobTriggerForm'

import usePipelineTrigger from './PipelineTrigger.hooks'
import type {PipelineTriggerProps} from './PipelineTrigger.types'

import styles from './PipelineTrigger.css'

function PipelineTrigger({
  parameters = {},
  onDisabled,
  onApply,
  onDelete,
  disabled,
}: PipelineTriggerProps) {
  const {
    isShowTriggerForm,
    daysOfWeekLabel,
    detailWhenTriggerLabel,
    timeLabel,
    timezone,
    parameterHour,
    parameterMinute,
    daysOfWeek,
    handlerJobTriggerApplyChange,
    handlerEditButtonClick,
    handlerJobTriggerFormClose,
  } = usePipelineTrigger(parameters, onApply)
  const triggerDetailsClassNames = classNames(styles.triggerDetail, {
    [styles.triggerDetailDisabled]: !disabled,
  })

  const handleDelete = useCallback(() => {
    onDelete?.()
    handlerJobTriggerFormClose()
  }, [handlerJobTriggerFormClose, onDelete])

  return (
    <div className={styles.trigger}>
      {isShowTriggerForm ? (
        <JobTriggerForm
          timezone={timezone}
          hour={parameterHour}
          minute={parameterMinute}
          daysOfWeek={daysOfWeek}
          onApply={handlerJobTriggerApplyChange}
          onDelete={handleDelete}
        />
      ) : (
        <div className={styles.triggerTime}>
          <Toggle
            onChange={onDisabled}
            className={styles.triggerToggle}
            size={Size.Size16}
            checked={disabled}
          />
          <div
            role="presentation"
            className={styles.triggerTimeWrapper}
            onClick={handlerEditButtonClick}
          >
            <div>
              {`Weekly: every ${daysOfWeekLabel} at ${timeLabel} (${timezone})`}
              <div className={triggerDetailsClassNames}>{detailWhenTriggerLabel}</div>
            </div>
            <EditButton
              iconClassName={styles.editTriggerIcon}
              className={styles.triggerActions}
              title="Edit"
              aria-label="Edit"
            />
          </div>
          <Actions className={styles.triggerActions} onDeleteClick={onDelete} />
        </div>
      )}
    </div>
  )
}

export default memo(PipelineTrigger)
